import { render } from "./ConfiguredCaseForm.vue?vue&type=template&id=aeb90444"
import script from "./ConfiguredCaseForm.vue?vue&type=script&lang=js"
export * from "./ConfiguredCaseForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__